import type { CSSProperties } from 'react';
import { DropdownMenu, IconButton } from '@ksyos/design-system';
import { styled } from 'styled-components';

interface IButtonHeaderProps {
    children?: JSX.Element;
    dropdownMenuItems?: IDropdownMenuItem[];
    style?: CSSProperties;
    title: JSX.Element;
}

export interface IDropdownMenuItem {
    onClick: () => void;
    text: string;
}

export function ButtonHeader(props: IButtonHeaderProps) {
    return (
        <StyledAddButtonHeader style={props.style}>
            <StyledTitle>{props.title}</StyledTitle>
            {props.children}
            {!!props.dropdownMenuItems?.length && (
                <DropdownMenu
                    trigger={
                        <IconButton
                            icon="more"
                            labelText="more"
                            sx={{ ml: 4 }}
                            variant="filled"
                        />
                    }
                >
                    {props.dropdownMenuItems.map((dropdownMenuItem, key) => (
                        <DropdownMenu.Item
                            key={key}
                            onClick={() => dropdownMenuItem.onClick()}
                        >
                            {dropdownMenuItem.text}
                        </DropdownMenu.Item>
                    ))}
                </DropdownMenu>
            )}
        </StyledAddButtonHeader>
    );
}

const StyledAddButtonHeader = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 24px;
`;

const StyledTitle = styled.div`
    flex: 1 1 0%;
`;
